class CartAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    ['onDocumentClick', 'onClickButton', 'onCartOpen'].forEach((eventName) => {
      this[eventName] = this[eventName].bind(this);
    });

    this.buttonEl = this.querySelector('[data-cart-accordion-button]');
    this.cart = document.querySelector('cart-drawer');

    document.addEventListener('click', this.onDocumentClick);

    if (this.buttonEl) {
      this.buttonEl.addEventListener('click', this.onClickButton);
    }

    // Check if animation has already played in this cart session
    if (this.cart?.hasAttribute('data-animation-played')) {
      this.toggleAnimationClass(false);
    }

    // Watch for cart opening
    if (this.cart) {
      this.observer = new MutationObserver(this.onCartOpen);
      this.observer.observe(this.cart, { attributes: true, attributeFilter: ['class'] });
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    if (this.buttonEl) this.buttonEl.removeEventListener('click', this.onClickButton);
    if (this.observer) this.observer.disconnect();
  }

  toggleAnimationClass(enable) {
    const pulseEl = this.querySelector(enable ? '.height-pulse-played' : '.height-pulse');
    if (pulseEl) {
      if (enable) {
        pulseEl.classList.add('height-pulse');
        pulseEl.classList.remove('height-pulse-played');
      } else {
        pulseEl.classList.remove('height-pulse');
        pulseEl.classList.add('height-pulse-played');
      }
    }
  }

  onCartOpen(mutations) {
    const isOpening = mutations.some(m => this.cart.classList.contains('active') && this.cart.classList.contains('animate'));
    const isClosing = mutations.some(m => !this.cart.classList.contains('active'));

    // Reset animation state when cart closes
    if (isClosing) {
      this.cart.removeAttribute('data-animation-played');
      this.toggleAnimationClass(true);
      return;
    }

    // Play animation once when cart opens, then mark as played
    if (isOpening && !this.cart.hasAttribute('data-animation-played')) {
      const pulseEl = this.querySelector('.height-pulse');
      if (pulseEl) {
        pulseEl.style.animation = 'none';
        requestAnimationFrame(() => {
          pulseEl.style.animation = '';
          pulseEl.addEventListener('animationend', () => {
            this.toggleAnimationClass(false);
            this.cart.setAttribute('data-animation-played', 'true');
          }, { once: true });
        });
      }
    }
  }

  onClickButton() {
    this.classList.toggle('is-open');
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.classList.remove('is-open');
    }
  }
}

customElements.define('vbb-cart-accordion', CartAccordion);
